export { default as ImageWithCaption } from "./ImageWithCaption";
export type { ImageWithCaptionProps } from "./ImageWithCaption";
